import type { SVGProps } from 'react'

interface LeafIconProps extends SVGProps<SVGSVGElement> {}

export function LeafIcon(props: LeafIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="currentColor"
      {...props}
    >
      <path d="M480-181.54q-54.33 0-102.36-17.88-48.02-17.89-87.1-49.89l-69.46 68.46q-8.18 8.31-20.82 8.31t-20.95-8.31q-8.31-8.3-8.31-20.95 0-12.64 8.31-20.81l68.46-68.47q-32-39.07-49.88-87.59Q180-427.2 180-481.54q0-125.62 87.19-212.81T480-781.54h239.23q25.31 0 43.04 17.73T780-720.77v239.23q0 125.63-87.19 212.81-87.19 87.19-212.81 87.19Zm0-60q100 0 170-70t70-170v-240H480q-100 0-170 70t-70 170q0 41.69 13.54 79.31 13.54 37.62 37.61 67.77l208.16-208.15q8.18-8.31 20.82-8.31t21.06 8.42q9.19 9.19 9.19 21.27t-9.3 21.38L332.92-292.08q30.16 24.08 67.77 37.31 37.62 13.23 79.31 13.23Zm0-240Z" />
    </svg>
  )
}
